export enum CASLActions {
  MANAGE = "manage",
}
